import $ from 'jquery';
window.$ = window.jQuery = $;

import {
	menuBurger,
	menuSubmenu,
	menuSearch
} from "./js/menu";
import {
	sliderAroundTheCity,
	sliderMostPopular
} from "./js/slider";
import {
	// modalPartners,
	// areaDropdown,
	emptyElementRemove
} from "./js/ui";

(($) => {
    $(() => {
		menuBurger()
		menuSubmenu()
		menuSearch()
		
		sliderAroundTheCity()
		sliderMostPopular()

		// modalPartners()
		// areaDropdown()
		emptyElementRemove()
	})
})(jQuery)